module.exports = __webpack_public_path__ + "img/Group 1000005947.58d1ea2d.png";